/* eslint-disable react/prop-types */
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import separate from "utils/separate";
import fixTableCellWidth from "../../utils/fixTableCellWidth";
import SoftBadge from 'components/SoftBadge';
import useModal from "hooks/useModal";
import { useState } from "react";
import Loading from "components/Loading";
import withdrawStatus from "enums/withdrawStatus";
import TableHeadItems from "./TableHeadItems";
import WithdrawInfoModal from "./WithdrawInfoModal";

function Row(props) {
    const { row, index, openMoreInfoModal } = props;

    return (
        <React.Fragment>
            <TableRow
                sx={{ "& > *": { borderBottom: "unset" }, backgroundColor: row.id % 2 === 1 ? "" : "rgba(204,204,204,0.1)" }}>
                <TableCell className="tablecell" align="left"
                    style={fixTableCellWidth("100px")}>{index + 1}</TableCell>
                <TableCell className="tablecell" align="left" title={separate(Number(row.amount))}
                    style={fixTableCellWidth("150px")}>{separate(Number(row.amount))}</TableCell>
                <TableCell className="tablecell" align="left" title={withdrawStatus(row.status)}
                    style={fixTableCellWidth("140px")}>{withdrawStatus(row.status)}</TableCell>
                <TableCell className="tablecell" align="left" title={row.created_at}
                    style={fixTableCellWidth("160px")}>{new Date(row.created_at).toLocaleString("fa-IR")}</TableCell>
                <TableCell className="tablecell" align="left"
                    style={fixTableCellWidth("100px")}>
                    <SoftBadge variant="contained"
                        badgeContent="جزئیات"
                        onClick={() => openMoreInfoModal(row)}
                        style={{ cursor: "pointer" }}
                        color="secondary" size="xs" />
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default function WithdrawTransactionsTable({ data, setWithdraw, onClearFilterClick, filterInfo, handleFilterChange, onFilterClick }) {
    const [modals, updateModal, closeInsideModal] = useModal({
        withdrawInfo: { state: false },
    });
    const closeWithdrawInfoModal = () => closeInsideModal("withdrawInfo");

    const openWithdrawInfoModal = (item) => {
        updateModal("withdrawInfo", { state: true, item })
    }


    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableHeadItems filterInfo={filterInfo} handleFilterChange={handleFilterChange} onClearFilterClick={onClearFilterClick} onFilterClick={onFilterClick} />
                    <TableRow>
                        <TableCell className="tablecell" style={fixTableCellWidth("100px")}>ردیف</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("140px")}>مبلغ</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("150px")}>وضعیت</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("150px")}>تاریخ ایجاد</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("100px")}>عملیات</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody style={{ display: "block" }}>
                    {data.map((row, index) => (
                        <Row key={row.id} index={index} row={row} openMoreInfoModal={openWithdrawInfoModal} />
                    ))}
                </TableBody>
            </Table>
            {modals.withdrawInfo.state && <WithdrawInfoModal modalInfo={modals.withdrawInfo} setWithdraw={setWithdraw} closeModal={closeWithdrawInfoModal} />}
        </TableContainer>
    );
}
